<template>
  <div class="m_context plr">
  <el-row>
	<el-col :span="24">
	 <el-form ref="addForm" id="addForm" :model="form" label-width="12.5%">
	 	<el-form-item :label="$t('lin_global.label_areaid')">
            <!--<el-select @change = "changeEvent" filterable clearable v-model="form.mechanismId" :placeholder="$t('lin_global.place_areaid')" class="w_33">-->
               <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
               <!--</el-option>-->
            <!--</el-select>-->

          <MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
        </el-form-item>
        <el-form-item :label="$t('lin_global.ter_num')">
        	<span style="padding-left: 10px;">  {{form.terNums}}  </span>{{$t('terminal.appLog.tower')}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.ota_bao')">
            <el-select filterable clearable v-model="form.otaId" :placeholder="$t('lin_global.ple_sel_ota')" class="w_33">
               <el-option v-for="item in otaList" :key="item.id" :label="item.name" :value="item.id">
               </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onCancel">{{$t('lin_btn.cancel')}}</el-button>
          <el-button type="primary" :loading="isSubmit" @click="submit">{{$t('lin_btn.lock')}}</el-button>
        </el-form-item>
	 </el-form>
	</el-col>
  </el-row>
  </div>
</template>
<script>
import axios from 'axios'
import { baseurl } from '../../api/url'
import MechanismSelector from '@/components/global/mechanism_selector.vue'
export default{
  components: {
    MechanismSelector
  },
	data(){
	  var that = this
		return{
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback (value) {
          that.form.mechanismId = value
          that.changeEvent()
        }
      },
      isSubmit: false,
			form:{
				mechanismId:'',
				otaId:'',
				terNums:0,
				mechanismName:''
			},
			areaList:[],
			otaList:[]
		}
	},
	created(){
//		this.getAd();
	},
	methods:{
		submit:function(){
			var params = this.form;
			//console.log("打印传入参数");
			//console.log(params)
      this.isSubmit = true;
			axios.post(`${baseurl}/ota_lock/lock.do`,params).then(res=>{
				//console.log("打印返回数据");
				//console.log(res.data)
	            if(res.data.status == 200){
	            	this.$message.success(res.data.message);
	            	this.$router.go(-1);
                this.isSubmit = false;
	            }else{
	            	this.$message.error(res.data.message);
                this.isSubmit = false;
	            }
	        })
		},
		changeEvent:function(){
			this.getNum();
			this.getName();
			this.getOta()
		},
		getNum:function(){
			var params={mechanismId:this.form.mechanismId}
			axios.post(`${baseurl}/terminal/terNums.do`,params).then(res=>{
		    		this.form.terNums = res.data.data.nums;
		    	})
		},
		getName:function(){
			var params = {id:this.form.mechanismId}
			axios.post(`${baseurl}/mechanism/detail.do`,params).then(res=>{
					//console.log("打印名称");
					//console.log(res.data);
		    		this.form.mechanismName = res.data.data.mechanismname;
		    	})
		},
		getOta:function(){
			var params={mechanismId:this.form.mechanismId}
			axios.post(`${baseurl}/ota_lock/ota_list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		this.otaList = res.data.data;
		    		//this.form.terNums = res.data.data.nums;
		    	})
		},
//		getAd:function(){
//		    	var params = {page:1,rows:10000};
//		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
//		    		//console.log(res.data);
//		    		this.areaList = res.data.data;
//		    	})
//		},
		onCancel:function(){
			this.$router.go(-1);
		}
	}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// ota.vue?b322e3e6